import { render, staticRenderFns } from "./NotificationsGrid.vue?vue&type=template&id=0d0cb9c1&"
import script from "./NotificationsGrid.vue?vue&type=script&lang=js&"
export * from "./NotificationsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports